<template>
  <div class="pc-dream">
    <!-- 院校头部面包屑部分 -->
    <div class="pc-dream-bread">
      <h2>地图列表</h2>
      <BreadCrumb :data="breadcrumb" class="pc-new-breadcrumb" />
    </div>
    <!-- city头部内容部分 -->

    <!-- <StatisticalPanel :whichModule="'map'" :title="'Urban Dream 数据'">
      <template v-slot>
        <div class="slot-first">
          <h1>{{ dreamTotal }}</h1>
          <p>Urban Dream 发布</p>
          <h2>{{ answerTotal }}</h2>
          <p>评论数</p>
        </div>
      </template>
    </StatisticalPanel> -->

    <div class="pc-region-table">
      <RegionTable ref="uniTable" />
    </div>
  </div>
</template>

<script>
import RegionTable from "./urbanDream/regionTable.vue";
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel";
import BreadCrumb from "../../template/BreadCrumb";

export default {
  data() {
    return {
      dreamTotal: 0,
      answerTotal: 0,
    };
  },
  components: {
    BreadCrumb,
    StatisticalPanel,
    RegionTable,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "地图管理", link: "/admin/regionList" },
        { name: "地图列表", link: "/admin/regionList" },
      ];
    },
  },
  created() {
    this.getTotalCount()
  },
  methods: {
    getTotalCount() {
      this.$axios.get("urban_bg_count", {}).then((res) => {
        // console.log(res.data);
        this.dreamTotal = res.data.q_count
        this.answerTotal = res.data.a_count
      })
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-dream {
  .slot-first {
    h1,
    h2 {
      margin-top: 20px;
      font-family: $chinese;
      font-size: 55px;
      font-weight: normal;
      color: $timeBtn;
      text-align: center;
    }
    p {
      margin-top: 15px;
      font-family: $chinese;
      font-size: 14px;
      font-weight: 400;
      color: $mainTitle;
      text-align: center;
    }
    h2 {
      margin-top: 30px;
      color: $lightenYellow;
    }
  }

  .pc-dream-bread {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid $border-color;
    > h2 {
      font-size: 20px;
      padding: 35px 40px 0 0;
      align-self: flex-end;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/audit/urbanDream.vue